import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import { service } from '@ember/service';
import type { Type } from '@warp-drive/core-types/symbols';
import type IntlService from 'ember-intl/services/intl';
import type GoalModel from 'scaleflow/models/goal';
import type InitiativeModel from 'scaleflow/models/initiative';
import type MetricModel from 'scaleflow/models/metric';
import localize from 'scaleflow/utils/localize';

export default class TargetModel extends Model {
  declare [Type]: 'target';

  @service declare intl: IntlService;

  @attr('number') declare start_value: number | null;
  @attr('number') declare target_value: number | null;
  @attr declare end_date: string | null;
  @attr declare start_date: string | null;
  @belongsTo('metric', {
    async: true,
    inverse: 'targets',
  })
  declare metric: AsyncBelongsTo<MetricModel>;
  @belongsTo('goal', {
    async: true,
    inverse: 'targets',
  })
  declare goal: AsyncBelongsTo<GoalModel>;

  @belongsTo('initiative', {
    async: true,
    inverse: 'targets',
  })
  declare initiative: AsyncBelongsTo<InitiativeModel>;

  get formattedTargetValue() {
    const symbol = this.metric.content?.symbol;
    if (!this.target_value) return undefined;
    if (symbol === 'percentage') return `${localize(this.target_value, '%')}`;
    if (symbol === 'currency')
      return `${localize(this.target_value, ',-', this.intl.t('currency.euro'))}`;
    return `${localize(this.target_value)}`;
  }
}
